/**
 * Map overview permissions
 */
export enum PermissionMapOverview {
  /** Přehled akce */
  MAP_OVERVIEW = 'MAP_OVERVIEW',
}
